<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style>
:root {
  --primary: #00adf2;
  --secondary: #e40084;
}

p a {
  color: var(--secondary) !important;
  font-weight: bold !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue